<template>
  <div>
    <vue-qrcode @getScanResult="handleCode"></vue-qrcode>
  </div>
</template>
<script>
import qrcode from "../components/ScanCode.vue";

export default {
  components: {
    "vue-qrcode": qrcode,
  },
  name: "qrcode",
  data() {
    return {};
  },
  created() {},
  methods: {
    handleCode(e) {
      this.$route.params.keyword = e;
      this.$router.back();
    },
  },
};
</script>